import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-project-add',
  templateUrl: './app-project-add.component.html',
  styleUrls: ['./app-project-add.component.scss']
})
export class AppProjectAddComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
